import Vue from 'vue'
import Router from 'vue-router'

import store from '../store'

import Index from '../views/Index'
import Home from '../views/Home'
import ActionChoice from '../views/ActionChoice'
import Closing from '../views/Closing'
import Settings from '../views/Settings'
import Ticket from '../views/Ticket'

import OfflineChoice from '../views/offline/OfflineChoice'
import InfoBadgeOffline from '../views/offline/InfoBadgeOffline'
import CashlessRefill from '../views/offline/CashlessRefill'
import ScanNfcOffline from '../views/offline/ScanNfcOffline'

import LoyaltyCheckCarrier from '../views/loyalty/LoyaltyCheckCarrier'
import LoyaltyGift from '../views/loyalty/LoyaltyGift'
import LoyaltyJackpot from '../views/loyalty/LoyaltyJackpot'
import LoyaltyQuestions from '../views/loyalty/LoyaltyQuestions'

import CreditGift from '../views/gift/CreditGift'
import GiftCard from '../views/gift/GiftCard'
import Vouchers from '../views/gift/Vouchers'

import Scan from '../views/scan/Scan'
import InfoBadge from '../views/scan/InfoBadge'
import InfoCommande from '../views/scan/InfoCommande'
import Voucher from '../views/scan/Voucher'

import Customer from '../views/customer/Customer'
import CustomerSearch from '../views/customer/CustomerSearch'

import MobilProducts from '../views/mobil/MobilProducts'
import MobilPayment from '../views/mobil/MobilPayment'

import BankingPayment from '../views/partner/BankingPayment'
import RestoFlash from '../views/partner/RestoFlash'
import W2S from '../views/partner/W2S'
import Tips from '../views/partner/Tips'
import Donation from '../views/partner/Donation'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      props: true
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      props: true
    },
    // Offline
    {
      path: '/offline-choice',
      name: 'offline-choice',
      component: OfflineChoice,
      props: true
    },
    {
      path: '/info-badge-offline',
      name: 'info-badge-offline',
      component: InfoBadgeOffline,
      props: true
    },
    {
      path: '/cashless-refill',
      name: 'cashless-refill',
      component: CashlessRefill,
      props: true
    },
    {
      path: '/scan-nfc-offline',
      name: 'scan-nfc-offline',
      component: ScanNfcOffline,
      props: true
    },
    // Scan
    {
      path: '/scan-nfc',
      name: 'scan-nfc',
      component: Scan,
      props: true
    },
    {
      path: '/scan-qrcode',
      name: 'scan-qrcode',
      component: Scan,
      props: true
    },
    {
      path: '/scan-qrcode-usb',
      name: 'scan-qrcode-usb',
      component: Scan,
      props: true
    },
    {
      path: '/scan-keyboard',
      name: 'scan-keyboard',
      component: Scan,
      props: true
    },
    {
      path: '/scan-swipe',
      name: 'scan-swipe',
      component: Scan,
      props: true
    },
    // Fidélité / Bons
    {
      path: '/loyalty-check-carrier',
      name: 'loyalty-check-carrier',
      component: LoyaltyCheckCarrier,
      props: true
    },
    {
      path: '/loyalty-gift',
      name: 'loyalty-gift',
      component: LoyaltyGift,
      props: true
    },
    {
      path: '/loyalty-jackpot',
      name: 'loyalty-jackpot',
      component: LoyaltyJackpot,
      props: true
    },
    {
      path: '/loyalty-questions',
      name: 'loyalty-questions',
      component: LoyaltyQuestions,
      props: true
    },
    // Cadeau
    {
      path: '/gift-card',
      name: 'gift-card',
      component: GiftCard,
      props: true
    },
    {
      path: '/vouchers',
      name: 'vouchers',
      component: Vouchers,
      props: true
    },
    {
      path: '/voucher',
      name: 'voucher',
      component: Voucher,
      props: true
    },
    // Fiche client
    {
      path: '/customer',
      name: 'customer',
      component: Customer,
      props: true
    },
    {
      path: '/customer-search',
      name: 'customer-search',
      component: CustomerSearch,
      props: true
    },
    {
      path: '/credit-gift',
      name: 'credit-gift',
      component: CreditGift,
      props: true
    },
    // Mobil
    {
      path: '/mobil-products',
      name: 'mobil-products',
      component: MobilProducts,
      props: true
    },
    {
      path: '/mobil-payment',
      name: 'mobil-payment',
      component: MobilPayment,
      props: true
    },
    // Partner
    {
      path: '/banking-payment',
      name: 'banking-payment',
      component: BankingPayment,
      props: true
    },
    {
      path: '/resto-flash',
      name: 'resto-flash',
      component: RestoFlash,
      props: true
    },
    {
      path: '/w2s',
      name: 'w2s',
      component: W2S
    },
    {
      path: '/tips',
      name: 'tips',
      component: Tips,
      props: true
    },
    {
      path: '/donation',
      name: 'donation',
      component: Donation,
      props: true
    },
    // Autres
    {
      path: '/info-badge',
      name: 'info-badge',
      component: InfoBadge,
      props: true
    },{
      path: '/info-commande',
      name: 'info-commande',
      component: InfoCommande,
      props: true
    },
    {
      path: '/action-choice',
      name: 'action-choice',
      component: ActionChoice,
      props: true
    },
    {
      path: '/closing',
      name: 'closing',
      component: Closing,
      props: true
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      props: true
    },
    {
      path: '/ticket',
      name: 'ticket',
      component: Ticket,
      props: true
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (from.name === 'home') {
    setTimeout(() => {
      store.commit('drawer', false)
    }, 200)
  }
  next()
  // setTimeout(() => {
  //   next()
  // }, 100)
})

export default router
